import axios from 'axios';
import { IdProps, OfferConfirmProps, OffersGetAllQuery, SendOfferProps } from '../../types';

class OffersService {
  send = ({ id, ...props }: SendOfferProps) => axios.post(`/offers/${id}`, props);

  getAll = (props: any) => axios.get<OffersGetAllQuery>('/offers', props);

  confirmPayment = (props: OfferConfirmProps[]) => axios.post(`/offers/confirm/payment`, props);

  confirm = ({ id, ...props }: OfferConfirmProps) => axios.post(`/offers/${id}/confirm`, props);

  update = ({ id, ...props }: SendOfferProps) => axios.patch(`/offers/update/${id}`, props);

  cancel = (props: IdProps[]) => axios.patch('/offers/cancel', props);

  cancelPaid = (props: IdProps) => axios.patch('/offers/cancel-paid', props);
}

export const offersService = new OffersService();
